<template>
  <div class="preview-box">
    <div class="preview-box-container">
      <div class="preview-box-title">
        <h2>Owner</h2>
      </div>
      <div
        class="preview-box-content"
        v-if="project.created_by.email"
      >
        <p>{{project.created_by.name}}</p>
        <p>{{project.created_by.email}}</p>
        <br />
        <p>
          <label>Email Verified: <span>{{project.created_by.email_verified ? '✅': 'No'}}</span></label>
        </p>
        <p>
          <label>Has Legacy Access: <span>{{haveLegacyAccess ? '✅': 'No'}}</span></label>
        </p>
      </div>
      <div v-else>
        Owner Profile Missing!
      </div>
      <hr v-if="project.created_by.email">
      <div v-if="project.created_by.email" class="preview-box-tools">
        <ConfirmView
          actionButtonText="Edit Owner"
          title="Owner Details"
          :action="actionEditOwnerDetails"
          @on-action-done="onActionDone"
        >
          <template v-slot:confirm>
            <input
              type="text"
              v-model="actionEditOwnerDetails.model.newName"
              placeholder="Name"
            />
            <input
              type="email"
              v-model="actionEditOwnerDetails.model.newEmail"
              placeholder="Email address"
            />
          </template>
        </ConfirmView>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ref,
  toRef,
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { ProjectList, AdminAction } from '@/store/modules/admin';
import ConfirmView from '@/components/admin/ConfirmView.vue';

export default {
  props: {
    project: Object,
  },
  components: {
    ConfirmView,
  },
  setup(props) {
    const store = useStore();
    const project = toRef(props, 'project');
    const projectKey = project.value.key;

    const haveLegacyAccess = computed(() => {
      const createdBy = props.project.created_by;
      return createdBy.properties && createdBy.properties.show_v2_console;
    });

    const actionEditOwnerDetails = ref(new AdminAction(
      () => ProjectList.editOwnerDetails(projectKey, actionEditOwnerDetails.value.model),
      null,
      {
        model: {
          newName: project.value.created_by?.name || '',
          newEmail: project.value.created_by?.email || '',
        },
      },
    ));

    const onActionDone = (context, updatedProject) => {
      store.commit('admin/updatePreviewProject', { project: updatedProject });
    };

    return {
      haveLegacyAccess,
      actionEditOwnerDetails,
      onActionDone,
    };
  },
};
</script>
